<template>
  <div class="Organized subWrapper">
    <!-- logo + menu -->
    <LogoMenu :loadmounted="ismobile" :active-name="menuName" />
    <!-- 组织机构 -->
    <div class="sub_contBox" v-if="!ismobile">
      <div class="contbox_scroll">
        <div class="contbox_top">
          <!-- 组织机构 txt -->
          <div class="sub_title"><img src="../assets/image/right_arrow.png" /><span>{{ OrganizedData.name }}</span><img src="../assets/image/left_arrow.png" /></div>
          <!-- 内容 -->
          <div class="sub_cont">
            <IndexOrganizated :organized-name="OrganizedData.name" :organized-data="OrganizedData.seminarSubTopics" />
          </div>
        </div>
        <!-- 底部信息 -->
        <Foot />
      </div>
    </div>
    <!-- pc -->
    <div class="sub_contBox" v-else>
      <!-- 面包屑 -->
      <div class="Breadcrumb_box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{ OrganizedData.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主体 -->
      <div class="content_box">
        <!-- 内容 -->
        <IndexOrganizated :organized-name="OrganizedData.name" :organized-data="OrganizedData.seminarSubTopics" />
      </div>
    </div>
    <!-- 底部信息 -->
    <Foot v-if="ismobile" />
  </div>
</template>

<script>
  import LogoMenu from '../components/LogoMenu.vue'
  import { OrganizedApi,AccessRecordsApi } from '../request/api.js'
  import IndexOrganizated from '../components/IndexOrganizated.vue'
  import Foot from '../components/Footer.vue'
  export default{
    name: "Organized",
    data(){
      return{
        OrganizedData: {},
        ismobile: false,
        menuName: ''
      }
    },
    created() {
      let wid = window.innerWidth;
      this.menuName = this.$route.query.name;
      if (wid >= 320 && wid <= 1024) {
        this.ismobile = false;
      } else {
        this.ismobile = true;
      }
    },
    mounted() {
      this.GetOrganizedFn();
      this.AccessRecordsFn();
    },
    methods:{
      // 访问记录
      AccessRecordsFn() {
        AccessRecordsApi({
          seminarTopicId: 5
        });
      },
      // 组织机构
      GetOrganizedFn(){
        OrganizedApi({
          Sorting: 'displayindex asc',
          ChildrenSorting: 'displayindex asc'
        }).then(res => {
          this.OrganizedData = res;
        });
      },
    },
    components:{
      LogoMenu,
      IndexOrganizated,
      Foot
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Organized.vue